"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Disclosure = function (_super) {
  __extends(Disclosure, _super);

  function Disclosure() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isExpanded: Boolean(_this.props.isDefaultExpanded)
    };

    _this.handleDisclosureClick = function () {
      _this.setState({
        isExpanded: !_this.state.isExpanded
      });
    };

    return _this;
  }

  Disclosure.prototype.componentDidUpdate = function (prevProps, prevState) {
    if (prevState.isExpanded !== this.state.isExpanded) {
      var onExpand = this.props.onExpand;
      onExpand && onExpand(this.state.isExpanded);
    }
  };

  Disclosure.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        label = _a.label,
        children = _a.children,
        isSection = _a.isSection;
    var isExpanded = this.state.isExpanded;
    var labelClass = isSection ? "disclosure--section" : "";
    var expandClass = isExpanded ? "disclosure--expanded" : "";
    return react_1["default"].createElement("div", {
      className: "disclosure " + (className || "")
    }, react_1["default"].createElement("div", {
      className: "disclosure__item " + expandClass + " " + labelClass
    }, react_1["default"].createElement("div", {
      className: "disclosure__label",
      onClick: this.handleDisclosureClick
    }, label), react_1["default"].createElement("div", {
      className: "disclosure__content"
    }, children)));
  };

  return Disclosure;
}(react_1["default"].Component);

exports["default"] = Disclosure;